var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.202 1.5 1.5 6.202 1.5 12S6.202 22.5 12 22.5 22.5 17.798 22.5 12 17.798 1.5 12 1.5m3.877 14.49-1.547-.008L12 13.205 9.673 15.98l-1.55.007a.187.187 0 0 1-.187-.188q.001-.067.044-.122l3.05-3.633-3.05-3.63a.188.188 0 0 1 .143-.31l1.55.008L12 10.889l2.327-2.775 1.547-.007c.103 0 .188.082.188.188a.2.2 0 0 1-.045.121l-3.044 3.63 3.047 3.634a.188.188 0 0 1-.143.31"
  })));
};
export default SvgCloseCircle;